// extracted by mini-css-extract-plugin
module.exports = {"error-section":"error_error-section__0knHD"};